import { Input } from './input.mjs';
import { create, registerCustomElement } from '../utils.mjs';

import classes from './file-list.module.scss';

type FileListInputInstructions = {
	description?: string;
	files: Array<{
		name: string;
		type: string;
	}>;
};

export const createFileIcon = (fileType: string) => {
	const icon = create('i.far.fa-file');
	const iconContainer = create(`span.${classes.fileType}`);
	iconContainer.append(icon);

	const fileIconClassMap: Record<string, string> = {
		pdf: classes.pdf,
		csv: classes.csv,
		txt: classes.txt,
		png: classes.png,
		json: classes.json,
	};

	const fileIconClass = fileIconClassMap[fileType];
	if (fileIconClass) {
		iconContainer.classList.add(fileIconClass);
	}

	return iconContainer;
};

export class FileListInput extends Input {
	async _build(instructions: FileListInputInstructions) {
		// .wrapper is used here so that collapsing correctly hides this component
		const wrapper = create('div.wrapper');

		if (instructions.description) {
			const description = create(`div.${classes.description}`);
			description.textContent = instructions.description;
			wrapper.appendChild(description);
		}

		const list = create(`ul.${classes.list}`);

		wrapper.appendChild(list);

		instructions.files.forEach((file) => {
			const item = create(`li.${classes.item}`);
			item.textContent = file.name;
			item.prepend(createFileIcon(file.type));
			list.appendChild(item);
		});
		this.appendChild(wrapper);
	}
}

registerCustomElement('imt-input-filelist', FileListInput);
